import * as React from 'react';
import { Dispatch } from 'react-redux';
import {
	DragDropContext,
	Droppable,
	DragStart,
	DropResult,
	DroppableProvided,
	DroppableStateSnapshot,
} from 'react-beautiful-dnd';

import { StyledThumbnails, ThumbnailsList } from './styles';
import ThumbnailsItem from '../../../containers/Editor/Thumbnails/ThumbnailsItem';
import ButtonAddPage from '../ButtonAddPage';
import { changePage, movePages } from '../../../containers/Editor/actions';
import { StoreState } from '../../../reducers';
import keys from '../../../utils/keys';
import { DndItemTypes } from '../../../typings/dnd';
import { Api } from '../../../typings/api';
import UserAgentUtils from '../../../utils/userAgent';

interface ThumbnailsProps {
	items: Api.EditorThumbnailData[];
	isDisplayed: boolean;
	currentPage: number;
	totalPages: number;
	isSomeEditableItemActive: boolean;
	isPageSelectionActive: boolean;
	selectedPages: number[];
	dispatch: Dispatch<StoreState>;
}

const Thumbnails = ({
	items,
	isDisplayed,
	currentPage,
	totalPages,
	isSomeEditableItemActive,
	isPageSelectionActive,
	selectedPages,
	dispatch,
}: ThumbnailsProps) => {
	const [activeDraggingItem, setActiveDraggingItem] = React.useState<number | null>(null);

	const handleDragStart = ({ source }: DragStart) => {
		if (isPageSelectionActive) {
			setActiveDraggingItem(source.index);
		}
	};

	const handleDragEnd = ({ source, destination }: DropResult) => {
		if (isPageSelectionActive) {
			setActiveDraggingItem(null);
		}

		const pagesToMove = isPageSelectionActive ? selectedPages : [source.index];

		if (!destination || pagesToMove.includes(destination.index)) {
			return;
		}

		dispatch(movePages(pagesToMove, destination.index));
	};

	React.useEffect(() => {
		if (!isDisplayed || isSomeEditableItemActive || isPageSelectionActive) {
			return;
		}

		const handleKeyDown = (e: KeyboardEvent) => {
			if (keys.isArrowUp(e.keyCode)) {
				e.preventDefault();
				if (currentPage > 1) {
					dispatch(changePage(currentPage - 1));
				}
			}

			if (keys.isArrowDown(e.keyCode)) {
				e.preventDefault();
				if (currentPage < totalPages) {
					dispatch(changePage(currentPage + 1));
				}
			}
		};

		window.addEventListener('keydown', handleKeyDown);

		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [currentPage, isDisplayed, isSomeEditableItemActive, isPageSelectionActive]);

	return (
		<StyledThumbnails isDisplayed={isDisplayed}>
			<DragDropContext
				onDragStart={handleDragStart}
				onDragEnd={handleDragEnd}
			>
				<Droppable
					droppableId="thumbnails"
					type={DndItemTypes.EDITOR_THUMBNAIL}
				>
					{(provided: DroppableProvided, snapshot: DroppableStateSnapshot) => (
						<ThumbnailsList
							ref={provided.innerRef}
							{...provided.droppableProps}
							isDraggingOver={snapshot.isDraggingOver}
							isMobileApp={UserAgentUtils.isMobileApp}
						>
							{items.map((item: Api.EditorThumbnailData) => (
								<ThumbnailsItem
									key={item.position}
									position={item.position}
									activeDraggingPosition={activeDraggingItem}
								/>
							))}
							{provided.placeholder}
						</ThumbnailsList>
					)}
				</Droppable>
			</DragDropContext>
			<ButtonAddPage />
		</StyledThumbnails>
	);
};

export default Thumbnails;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/index.tsx